// extracted by mini-css-extract-plugin
module.exports = {"container":"i_J2","light":"i_J3","dark":"i_J4","value":"i_J5","select":"i_J6","heading":"i_J7"};